var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('module-card',[_c('p',[_vm._v("Great job! Here's a summary of the 12 steps to effective condom use:")]),_c('ol',_vm._l((_vm.steps),function(step){return _c('li',{key:step.order},[_vm._v(_vm._s(step.step))])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }